import { render, staticRenderFns } from "./SysDictTypeTree.vue?vue&type=template&id=a2dcddf2&scoped=true&"
import script from "./SysDictTypeTree.vue?vue&type=script&lang=js&"
export * from "./SysDictTypeTree.vue?vue&type=script&lang=js&"
import style0 from "./SysDictTypeTree.vue?vue&type=style&index=0&id=a2dcddf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dcddf2",
  null
  
)

export default component.exports